_ = require 'underscore'
BaseDirectoryView = require './base-directory-view'
formatNumber = require 'app/scripts/lib/format/number'
{ getKey, Key } = require '@trello/keybindings'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('directory')
{ UpgradePromptFullConnected: UpgradePromptFull } = require 'app/src/components/UpgradePrompts/UpgradePromptFull'
{ PowerUpTestIds } = require '@trello/webdriverio-tests'
{ categories } = require('app/scripts/data/directory')
{ IconName } = require 'app/common/components/controls'
Controller = require 'app/scripts/controller'
l = require 'app/scripts/lib/localize'
{ trackUe } = require '@trello/analytics'
{ dontUpsell } = require '@trello/config'
Auth = require 'app/scripts/db/auth'

UPGRADE_PROMPT_PUP_DIRECTORY = 'upgrade-prompt-pup-directory'

class DirectorySidebarPlaceholder extends React.Component
  displayName: 'Directory Sidebar Placeholder'

  render: t.renderable ->
    t.div ->
      t.div '.directory-search', ->
        t.div '.directory-navigation-option.placeholder'
      t.ul ->
        t.li ->
          t.div '.directory-navigation-option.placeholder'
        t.li ->
          t.div '.directory-navigation-option.placeholder'
        t.li ->
          t.div '.directory-navigation-option.placeholder'
        t.li '.directory-categories', ->
          t.div '.directory-categories-heading.placeholder', ->
          t.ul '.directory-navigation-categories-list', ->
            _.forEach categories, (categoryKey) ->
              t.li ->
                t.div '.directory-navigation-option.placeholder'

class DirectorySidebar extends React.Component
  displayName: 'Directory Sidebar'

  constructor: (props) ->
    super(props)

    @state = {
      shouldShowUpgradePrompt: props.shouldShowUpgradePrompt
    }

    @directorySearchInput = null

  componentDidMount: ->
    @focusDirectorySearchInput()

  focusDirectorySearchInput: =>
    @directorySearchInput?.focus()

  render: t.renderable ->
    setDirectorySearchInput = (el) => @directorySearchInput = el

    { enabledCount, showCustomCategory, clearSearch, section, category, idPlugin,
      onCategoryClick, onHomeClick, onEnabledClick, onCustomClick, onSearchKeyUp, billingUrl } = @props
    { shouldShowUpgradePrompt } = @state

    t.div =>
      t.div '.directory-search', ->
        t.input '.js-directory-search' , {
          type: 'text',
          placeholder: t.l('search'),
          onKeyUp: onSearchKeyUp,
          ref: setDirectorySearchInput
        }
        t.a '.icon-sm.icon-close.dark-hover.hide.js-directory-search-clear', { href: '#', onClick: clearSearch }
      t.div '.directory-navigation-section', =>
        t.ul =>
          t.li { onClick: onHomeClick }, ->
            t.a '.directory-navigation-option', { href: '#', class: t.classify({
              'active': !section && !category && !idPlugin
              }) }, ->
                t.formatText 'featured'
          t.li { onClick: onEnabledClick }, ->
            t.a '.directory-navigation-option.enable-option', {
              href: '#',
              class: t.classify({
                'active': section == 'enabled'
              }),
              'data-test-id': PowerUpTestIds.EnabledPowerUpsLink
            }, ->
              t.formatText 'enabled'
              t.span '.directory-navigation-power-up-count', ->
                t.text enabledCount
          if showCustomCategory
            t.li { onClick: onCustomClick }, ->
              t.a '.directory-navigation-option', { href: '#', class: t.classify({ 'active': section == 'custom' }) }, ->
                t.formatText 'custom'

          if shouldShowUpgradePrompt
            t.addElement React.createElement UpgradePromptFull,
              headline: l(['upgrade prompt', 'board menu', 'power ups', 'headline'])
              content: l(['upgrade prompt', 'board menu', 'power ups gallery', 'body content'])
              cta: l(['upgrade prompt', 'learn more'])
              ctaLink: billingUrl
              isDismissable: true
              onDismiss: =>
                Auth.me().dismiss(UPGRADE_PROMPT_PUP_DIRECTORY)
                @setState({ shouldShowUpgradePrompt: false })
              ctaTrackEvent: -> trackUe(
                'pups page',
                'opens',
                'team page bc tab',
                '',
                '',
                'by clicking full upgrade prompt in pups page enabled section'
              )
              iconName: IconName.PowerUp
              isDarkTheme: false

      t.div '.directory-navigation-section', ->
        t.ul ->
          _.forEach categories, (categoryKey) ->
            t.li { onClick: -> onCategoryClick(categoryKey) }, ->
              t.a '.directory-navigation-option.category-link', {
                class: t.classify({ 'active': category == categoryKey })
                href: '#'
              }, ->
                t.format categoryKey

module.exports = class DirectorySidebarView extends BaseDirectoryView
  className: 'directory-sidebar js-directory-sidebar'

  initialize: ({ @directoryView }) ->
    super

    @onSearchKeyUp = _.debounce @onSearchKeyUp, 100

    @listenTo @model, 'change:powerUps': @render
    @listenTo @model.boardPluginList, 'add remove reset': @render
    @subscribe pluginsChangedSignal(@model), => @render()

  updateSearch: (search) ->
    @directoryView.updateSearch(search)

    clearButton = @$('.js-directory-search-clear')
    if search?.length
      clearButton.removeClass('hide')
    else
      clearButton.addClass('hide')

    @directoryView.headerView.render()

  onSearchKeyUp: (e) ->
    search = e.target.value
    key = getKey(e)

    if key == Key.Escape
      search = null
      @emptySearchField()

    # Close the responsive sidebar on Enter
    if key == Key.Enter && @$el.hasClass('active')
      @directoryView.toggleNavigationMenu()

    # Make sure the value has changed.
    if search != @directoryView.search
      @updateSearch(search)

  emptySearchField: ->
    @$('.js-directory-search').val('')

  clearSearch: ->
    @emptySearchField()
    @updateSearch(null)

  navigateTo: (section, category) ->
    @directoryView.navigate({ section, category })

    if @$el.hasClass('active')
      @directoryView.toggleNavigationMenu()

  renderContent: ->
    { section, category, idPlugin, history, isLoading, model } = @directoryView

    if (isLoading)
      return React.createElement DirectorySidebarPlaceholder

    enabledCount = ''

    totalEnabled = @model.get('powerUps').length + @model.powerUpsCount()

    if totalEnabled > 0
      enabledCount = formatNumber(totalEnabled)

    org = model.getOrganization()
    me = Auth.me()
    isPremium = org?.isPremium()
    hasBCPups = me.hasBCPowerUps()
    billingUrl = if org then Controller.getOrganizationBillingUrl(org) else '/business-class'
    isDismissed = me.isDismissed(UPGRADE_PROMPT_PUP_DIRECTORY)

    shouldShowUpgradePrompt = (
      org &&
      !dontUpsell &&
      !isPremium &&
      !hasBCPups &&
      !isDismissed
    )

    React.createElement DirectorySidebar, {
      enabledCount
      section
      idPlugin
      category: category || (idPlugin? && _.last(history)?.category)
      showCustomCategory: !_.isEmpty @directoryView.getCustomPlugins()
      clearSearch: => @clearSearch()
      onSearchKeyUp: (e) =>
        e.persist()
        @onSearchKeyUp(e)
      onCategoryClick: (categoryKey) => @navigateTo('category', categoryKey)
      onHomeClick: => @navigateTo()
      onEnabledClick: => @navigateTo('enabled')
      onCustomClick: => @navigateTo('custom')
      billingUrl
      shouldShowUpgradePrompt
    }
